<ps20-shop-design-container></ps20-shop-design-container>
<ng-template #waitingpage>
  <nxt-spinner-overlay>
    <img
      alt="Allianz Logo"
      src="/assets/allianz.svg" />
    <p
      [innerHTML]="'loadingOverlay' | html"
      class="nx-margin-top-2m nx-margin-bottom-s"
      nxCopytext="large"></p>
  </nxt-spinner-overlay>
</ng-template>
@if (
  !(
    (errorpageIsOpen$ | async) ||
    (sessionExpired$ | async) ||
    (constructionpageIsOpen$ | async) ||
    (userloggedout$ | async) ||
    (vnAddressInvalidPageOpen$ | async)
  )
) {
  @if (appIsInitialized$ | async) {
    @if (mainFilenameToolbar$ | async; as mainFilename) {
      @if (shouldShowToolbar(getLocation())) {
        <div
          id="shop-toolbar-app-root"
          class="shop-toolbar">
          <custom-toolbar
            *axLazyElement="'toolbar/' + mainFilename"
            [dispatcher]="globalEventDispatcher"></custom-toolbar>
        </div>
      }
    }
    @if ((forwardedToUnderwriterPageOpen$ | async) === false) {
      <router-outlet></router-outlet>
      <ps20-frontend-modal
        (buttonClicked)="triggerModalAction($event)"
        [modalOpen]="(modalData$ | async)?.modalOpen"
        [styleObject]="(modalData$ | async)?.styleObject"
        [textContent]="(modalData$ | async)?.textContent"
        [disableClose]="(modalData$ | async)?.disableClose">
      </ps20-frontend-modal>
    }
  }
}

@if (errorpageIsOpen$ | async) {
  <ps20-shop-errorpage></ps20-shop-errorpage>
}

@if (sessionExpired$ | async) {
  <ps20-shop-session-expired-page></ps20-shop-session-expired-page>
}

@if (userloggedout$ | async) {
  <ps20-shop-logoutpage></ps20-shop-logoutpage>
}

@if (constructionpageIsOpen$ | async) {
  <ps20-shop-constructionpage></ps20-shop-constructionpage>
}

@if (forwardedToUnderwriterPageOpen$ | async) {
  <ps20-shop-forwarded-to-underwriter-page></ps20-shop-forwarded-to-underwriter-page>
}

@if (vnAddressInvalidPageOpen$ | async) {
  <ps20-shop-vn-address-invalid></ps20-shop-vn-address-invalid>
}
@if (showDevMockPanel) {
  <ps20-shop-dev-mock-panel></ps20-shop-dev-mock-panel>
}
